import * as React from 'react';

export const GoalSettingTab = () => {
  return <div>TBA tab content: GoalSettingTab</div>;
};
